import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-donation-onglet',
  templateUrl: './donation-onglet.component.html',
  styleUrls: ['./donation-onglet.component.scss']
})
export class DonationOngletComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
